var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLiveChatSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4C2.3457031,2,1,3.3457031,1,5v16c0,1.6542969,1.3457031,3,3,3l3-0.0019531v3.5878906 C7,28.9169922,8.0830078,30,9.4140625,30c0.6357422,0,1.2578125-0.2578125,1.7070312-0.7070312l5-5 C16.3076172,24.1064453,16.5654297,24,16.828125,24H28c1.6542969,0,3-1.3457031,3-3V5C31,3.3457031,29.6542969,2,28,2z M29,21 c0,0.5517578-0.4482422,1-1,1H16.828125c-0.8007812,0-1.5546875,0.3125-2.1210938,0.8789062l-5,5 C9.46875,28.1181641,9,27.9238281,9,27.5859375V24c0-1.1025391-0.8974609-2-2-2H4c-0.5517578,0-1-0.4482422-1-1V5 c0-0.5517578,0.4482422-1,1-1h24c0.5517578,0,1,0.4482422,1,1V21z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 18,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 12,
    width: 18,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 17,
    width: 10,
    height: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveChatSmall);
export default __webpack_public_path__ + "static/media/live-chat--small.1e8426141bd1212ee8f5edcd43cdd453.svg";
export { ForwardRef as ReactComponent };